import { TempUserService } from './tempUserService';
import { getApiBaseUrl } from './getApiUrl';

export class GlobalMergeService {
  private static mergeAttempted = false;

  // Global merge: migrate temp homeowner to real user via POST /api/signup (same as migrateIfNeeded)
  static async attemptMerge(user: any): Promise<boolean> {
    if (this.mergeAttempted) {
      console.log('🔄 Merge already attempted, skipping');
      return false;
    }

    try {
      console.log('🌐 Global merge service triggered');
      const tempSessionId = TempUserService.getTempUuid();
      console.log('🔍 Temp UUID found:', tempSessionId);

      if (!tempSessionId) {
        console.log('⚠️ No temp UUID found, skipping merge');
        return false;
      }

      if (!user || !user.id) {
        console.log('⚠️ No user data available, skipping merge');
        return false;
      }

      const email = user.emailAddresses?.[0]?.emailAddress || user.primaryEmailAddress?.emailAddress || '';
      if (!email) {
        console.log('⚠️ No email for user, skipping merge');
        return false;
      }

      // Set flag BEFORE the async fetch to prevent concurrent duplicate runs (Strict Mode etc.)
      this.mergeAttempted = true;

      console.log('🔄 Attempting global merge via signup:', {
        tempSessionId,
        userUuid: user.id,
        email,
      });

      const base = getApiBaseUrl();
      const url = base ? `${base.replace(/\/$/, '')}/api/signup` : '/api/signup';
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          user_id: user.id,
          email,
          account_type: 'HOMEOWNER',
          temp_session_id: tempSessionId,
        }),
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || `Signup merge failed: ${res.status}`);
      }

      console.log('✅ Global merge successful');
      TempUserService.clearTempUuid();
      try {
        localStorage.removeItem('temp_session_id');
      } catch {}
      return true;
    } catch (error) {
      console.error('❌ Global merge failed:', error);
      return false;
    }
  }

  // Reset merge attempt flag (useful for testing)
  static resetMergeAttempt(): void {
    this.mergeAttempted = false;
    console.log('🔄 Merge attempt flag reset');
  }

  // Check if merge has been attempted
  static hasMergeBeenAttempted(): boolean {
    return this.mergeAttempted;
  }
} 